export default __webpack_public_path__ + "static/media/The Will of the City.ab31ae55.png";